
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({ name: 'TreeView' })
export default class TreeView extends Vue {
    @Prop({ required: true }) item!: Record<string, any>
    @Prop({ required: true }) items!: Array<any>

    loading = true

    get treeArr() {
        const treeArr = [] as Array<any>

        const recurseBuilder = function (item: any, items: Array<any>) {
            const storeItem = items.find((val) => val.id == item.id)
            if (storeItem) {
                treeArr.push(storeItem)
                if (storeItem?.parent?.data) {
                    recurseBuilder(storeItem.parent.data, items)
                }
            }
        }

        recurseBuilder(this.item, this.items)

        if (this.item && treeArr.length > 0) {
            this.loading = false
        }

        return treeArr
    }
}
